import React from 'react';
import ComicPanel from '../components/ui/ComicPanel';
import SpeechBubble from '../components/ui/SpeechBubble';
import { FiMail, FiUsers, FiClock, FiHeart } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      {/* Header Section */}
      <div className="text-center mb-20 relative">
        <div className="inline-block bg-hcf-yellow border-4 border-black p-4 shadow-comic transform -rotate-1">
          <h1 className="font-comic text-6xl md:text-8xl text-black drop-shadow-[4px_4px_0_#EC008C]">OUR STORY</h1>
        </div>
        <div className="mt-6 flex justify-center gap-4">
          <div className="bg-hcf-pink text-white font-comic text-2xl px-4 py-1 border-2 border-black rotate-2 shadow-comic-sm">EST. 2015</div>
          <div className="bg-hcf-cyan text-white font-comic text-2xl px-4 py-1 border-2 border-black -rotate-2 shadow-comic-sm">STILL LAUGHING</div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-24">
        <div className="order-2 md:order-1">
          <div className="bg-white border-4 border-black p-8 shadow-comic relative">
            <div className="absolute -top-4 -left-4 bg-hcf-purple text-white p-2 border-2 border-black">
              <SafeIcon icon={FiClock} className="text-2xl" />
            </div>
            <p className="font-body text-2xl leading-relaxed mb-6">
              Hastings Comedy Festival originated in <span className="font-bold text-hcf-pink">2015</span> from an idea by Co-directors <span className="text-hcf-cyan font-comic text-3xl">Chris and Jake</span>, uniting their passion for Live Comedy and the community of Hastings and St Leonards.
            </p>
            <p className="font-body text-xl">
              The independent festival showcases a large variety of professional comedians and emerging comics from around the UK and the world.
            </p>
          </div>
        </div>
        <div className="order-1 md:order-2">
          <ComicPanel className="bg-hcf-gradient p-2 rotate-2">
            <img src="https://images.unsplash.com/photo-1517457373958-b7bdd4587205?q=80&w=800&auto=format&fit=crop" className="w-full h-80 object-cover border-4 border-black grayscale contrast-125" alt="Hastings Scene" />
          </ComicPanel>
        </div>
      </div>

      {/* Ethos Quote Section - Updated background to Purple for better contrast */}
      <div className="mb-24 relative">
        <div className="absolute -top-12 left-1/2 -translate-x-1/2 z-10 bg-hcf-yellow border-4 border-black p-4 rounded-full shadow-comic">
          <SafeIcon icon={FiUsers} className="text-5xl text-black" />
        </div>
        <SpeechBubble direction="left" variant="purple" className="border-white shadow-glow max-w-4xl mx-auto">
          <div className="space-y-6 py-4">
            <span className="text-hcf-yellow font-bold italic text-3xl block leading-tight">
              "We have a big passion for finding, supporting and promoting new comedy talent, which is at the core of our ethos of running the festival."
            </span>
            <div className="h-1 w-24 bg-white/30 mx-auto"></div>
            <span className="text-white font-body text-2xl block font-bold">
              If you're looking for the future bright stars of stand up comedy then Hastings is the festival showcase you really shouldn't miss out on!
            </span>
          </div>
        </SpeechBubble>
      </div>

      {/* Logistics Panel */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-20">
        <div className="md:col-span-8">
          <div className="bg-white border-4 border-black p-8 shadow-comic transform -rotate-1">
            <h3 className="font-comic text-4xl mb-4 flex items-center gap-3">
              <SafeIcon icon={FiHeart} className="text-hcf-pink" /> THE FESTIVAL
            </h3>
            <p className="font-body text-xl mb-6">
              Shows are performed over <span className="font-bold border-b-4 border-hcf-yellow">7 days in June</span> at various venues throughout Hastings & St Leonards in East Sussex.
            </p>
            <p className="font-body text-xl">
              Save the dates as the festival once again promises to be an explosion of laughter. Join us in 2026 for our biggest year yet!
            </p>
          </div>
        </div>
        <div className="md:col-span-4">
          <div className="bg-hcf-cyan border-4 border-black p-6 shadow-comic flex flex-col items-center text-center h-full justify-center rotate-1">
            <SafeIcon icon={FiMail} className="text-6xl text-white mb-4" />
            <h4 className="font-comic text-3xl text-black mb-2">GET IN TOUCH</h4>
            <p className="font-body text-lg font-bold mb-4">You can contact Chris and Jake at:</p>
            <a href="mailto:Hastingscomedyfestival@yahoo.com" className="bg-black text-white px-4 py-2 font-body font-bold text-sm hover:bg-white hover:text-black transition-colors border-2 border-black" >
              Hastingscomedyfestival@yahoo.com
            </a>
          </div>
        </div>
      </div>

      {/* Secondary Image Strip */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          "https://images.unsplash.com/photo-1543584730-05c42d38448a?q=80&w=400&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1527236438218-d82077ae1f85?q=80&w=400&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1516280440614-37939bbacd81?q=80&w=400&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=400&auto=format&fit=crop"
        ].map((url, i) => (
          <div key={i} className="border-4 border-black h-40 overflow-hidden shadow-comic-sm grayscale hover:grayscale-0 transition-all cursor-crosshair">
            <img src={url} className="w-full h-full object-cover" alt="Festival Moments" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;